import React, { useState } from "react";
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Collapse,
  IconButton
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { red } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import { t } from "i18next";

const MissedDealerError = ({ missingDealers, studios }) => {
  const [open, setOpen] = useState(false);
  
  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const shiftsNames = {
    1: "Morning",
    2: "Night",
  }

  return (
    <div>
      {Object.entries(missingDealers).length ? (
        <Paper elevation={3} style={{ padding: "16px", marginBottom: "24px", backgroundColor: "#ffebee" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }} onClick={handleToggle}>
            <Typography variant="h6" gutterBottom style={{ display: "flex", alignItems: "center", color: red[700] }}>
              <ErrorIcon fontSize="small" style={{ marginRight: "8px"}} />
              Missing Dealers
            </Typography>
            <IconButton size="small">
              {open ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </div>

          <Collapse in={open}>
            <Grid container>
              {[{shift: 1, label: "morning"}, {shift: 2, label: "night"} ].map((shiftInfo) => {
                return <Grid key={shiftInfo.label} size={{ xs: 12 }}>
                  <Typography variant="body2" gutterBottom style={{ fontWeight: 600 }}>
                    {t(shiftInfo.label)}
                  </Typography>
                  {Object.entries(missingDealers).map(([studioId, dates]) => {
                    const hasShift = Object.values(dates).some(
                      (shifts) => shifts[shiftInfo.shift]
                    );
                    if (!hasShift) return null
                    return (
                      <div key={studioId} style={{ marginBottom: "16px" }}>
                        <Typography variant="h6" gutterBottom style={{fontSize: 16, fontWeight: 400}}>
                          Studio <b>{studios.find(studio => studio?.id == studioId)?.name}</b>
                        </Typography>
  
                        {Object.entries(dates).map(([date, shifts]) => {
                          // checking if does not exist any mssing dealer for that date we do not print it
                          if (!shifts[shiftInfo.shift]) return null;
                          return (
                            <div key={date} style={{ marginBottom: "12px" }}>
                              <Typography variant="subtitle1" gutterBottom style={{ fontWeight: "bold", color: red[900], fontSize: 16 }}>
                                Date: {date}
                              </Typography>
    
                              <List dense style={{ padding: 0 }}>
                                {Object.entries(shifts).map(([shiftType, count]) => {
                                  if (shiftType != shiftInfo.shift) return
                                  return (
                                    <ListItem key={shiftType} style={{ padding: "4px 0" }}>
                                      <ListItemText
                                        
                                        primary={`${count} missing dealers`}
                                        primaryTypographyProps={{ variant: "body1", style: { color: red[700], fontSize: 16 } }}
                                      />
                                    </ListItem>
                                  )
                                })}
                              </List>
                            </div>
                          )
                        })}
  
                        <Divider style={{ margin: "12px 0", backgroundColor: red[200] }} />
                      </div>
                    )
                  })}
                </Grid>
              })}
  
            </Grid>
            
          </Collapse>
        </Paper>
      ) : null}
    </div>
  );
};

export default MissedDealerError;
